import { call, put } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { Action } from '@reduxjs/toolkit';
import { displaySimpleNotification } from 'features/notifications/simple-notifications/displaySimpleNotification';
import i18n from 'i18n';
import { sendLobbyMessageRequested } from 'features/room/actions';

export function* sendLobbyMessageSaga(action: ReturnType<typeof sendLobbyMessageRequested>) {
  yield call(SignalingSocket.send, {
    event: 'sendLobbyMessage',
    data: {
      message: action.payload,
    },
  });

  const notificationThunk: Action = yield call(displaySimpleNotification, {
    content: i18n.t('notifications:lobby_message.message_sent'),
  });
  yield put(notificationThunk);
}
